import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { Bell, ChevronDown } from "react-feather";
import { P } from "../../../../AbstractElements";

export const StaticAccordion = () => {
  return (
    <AccordionItem>
      <AccordionHeader targetId="1" className="gap-2 bg-light-warning txt-warning">
        <Bell className="svg-wrapper me-2 text-warning"/><span className="text-warning">Keep in touch</span><ChevronDown className="svg-color text-warning" />
      </AccordionHeader>
      <AccordionBody accordionId="1">
        <P>
          <em className="txt-danger"> " This page might not behave as expected because Windows Internet Explorer isn't configured to load unsigned ActiveX controls."</em> or "Allow this page to install an unsigned ActiveX Control? Doing so from untrusted sources may harm your computer." (Both phrased as conditions that may cause future problems.)
        </P>
      </AccordionBody>
    </AccordionItem>
  );
};
